import script from "./VehicleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleDetail.vue?vue&type=script&setup=true&lang=js"

import "./VehicleDetail.vue?vue&type=style&index=0&id=01ccc45a&lang=css"

const __exports__ = script;

export default __exports__